import React, { useState, useEffect } from "react";
import {Label} from 'reactstrap'
// import { motion } from "framer-motion";
// import tw from "twin.macro";
// import styled from "styled-components";
// import Select from 'react-select';
// import { css } from "styled-components/macro"; 
// import { ReactComponent as SvgDecoratorBlob1 } from "images/svg/svg-decorator-blob-5.svg";
// import { ReactComponent as SvgDecoratorBlob2 } from "images/svg/svg-decorator-blob-7.svg";
import Noimg from "../images/no_img.jpg";
import { getProduct } from "../api/ProductApi.js";
import { currentRegister} from "utility/Constant.js";
import { Link, useNavigate } from "react-router-dom";
// import ProductCommon from "../components/ProductLike&Wish";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import no_data from "images/no_data.png";
// import SkeletonLoader from "components/SkeletonLoader";
import { useLocation } from "react-router-dom";
import { getBranchId } from "utility/HeaderConfig";
import BannerImage from '../images/maha_v2.jpeg'
import { ECommerce } from "api/AppConfigApi";
import "./VelSeriesDetails.css"; // Import the new CSS

// const Container = tw.div`relative font-display overflow-hidden`;
// const TabContent = tw(motion.div)`block `;
// const CardContainer = tw.div`mt-4 w-full relative`;
// const Card = tw(
//   motion.div
// )`bg-white block mx-auto  sm:mx-0 no-underline hover:shadow-2xl rounded-lg duration-500 cursor-pointer `;
// const CardImageContainer = styled.div`
//   ${(props) =>
//     css`
//       background-image: url("${props.imageSrc}");
//     `}
//   ${tw`bg-center bg-cover relative h-80 border border-gray-400 border-solid rounded-t-lg `}
// `;
// const CardText = tw.div`p-4 pb-1 text-gray-900 bg-gray-200 border border-gray-400 border-solid rounded-b-lg`;
// const CardTitle = tw.h5`text-sm group-hover:text-yellow-600 no-underline  text-gray-600 lowercase`;
// const CardContent = tw.p`mt-1 mb-2 text-sm font-medium text-custom-100  uppercase`;
// const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
//   ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
// `;
// const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
//   ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-custom-100`}
// `;

const VelSeriesDetails = () => {
  const history = useNavigate();
  const location = useLocation();
  // const occationCateData = location.state.occasionCate; 

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(12);
  const [banner, setBanner] = useState([]);
  // const [occasionDetails, setOccasionDetails] = useState({})
  // const [orderStatusSale, setOrderStatusSale] = useState("");
  // const [orderStatusTransfer, setOrderStatusTransfer] = useState("");
  // const [orderStatusSold, setOrderStatusSold] = useState("");
  // const [selectedOption,setSelectedOption] = useState({id: 3,label:'MAHAVEL',value:'/108 MAHAVEL'})
  const [selectedCategory, setSelectedCategory] = useState({value: 'All', label: 'All'});
  const [uniqueCategories, setUniqueCategories] = useState([]);
  // const [colorCode,setColorCode] = useState('')
  const [selectedLanguage, setSelectedLanguage] = useState({value: 'EN', label: 'English'});
  const showHeaders = (location.state?.isDashboard !== undefined && location.state?.isDashboard !== null) ? location.state?.isDashboard : false

const categoryOptions = uniqueCategories.map(category => ({
  value: category,
  label: category
}));

const filteredProducts = selectedCategory.label === "All" 
  ? categoryList 
  : categoryList.filter(item => item.categoryName === selectedCategory.label);
  
const languageOptions = [
  { value: 'EN', label: 'English' },
  { value: 'TA', label: 'தமிழ்' }
];

  // const pageList = [
  //   {id: 1,label:'NEW ARRIVALS',value:'/NewArrivals'},
  //   {id: 2,label:'MOST LIKED PRODUCT',value: '/MostLiked'},
  //   {id: 4,label:'TREND ON SHOPS',value:'/TrendOnShopComponent'},
  //   {id: 5,label:'SHOP OUR EXCLUSIVE',value: '/ShopOurExclusiveComponent'},
  //   {id: 6,label:'BEST SELLING',value:'/BestSellingComponent'},
  // ];

  useEffect(() => {
    Promise.all([
      getVelProductDetails(),
      // getOrderStatusSale(),
      // getOrderStatusTransfer(),
      // getOrderStatusSold(),
      banners()      
    ])
    .then((result) => {
      // if(location?.state?.occasionCate){
        // setOccasionDetails({
        //   name :occationCateData.name ? occationCateData.name:"", 
        //   displayName : occationCateData.displayName ? occationCateData.displayName : ""
        // })
        getOccation(result[0], result[1], result[2]);
        console.log("saedfsd",location);
        if (location.state?.languageInfo && location.state?.languageInfo !== undefined) {
          setSelectedLanguage(location.state?.languageInfo)
        }
        
      // }
    })
    .catch((err) => console.error(err));
    //eslint-disable-next-line
  }, []);

  // const getOrderStatusSale = () => {
  //   return orderStatus({ orderStatusName: "sale" })
  //     .then((data) => {
  //       setOrderStatusSale(data.response[0].id);
  //       return data.response[0].id;
  //     })
  //     .catch((err) => console.error(err));
  // };

  // const getOrderStatusTransfer = () => {
  //   return orderStatus({ orderStatusName: "Transferred" })
  //     .then((data) => {
  //       setOrderStatusTransfer(data.response[0].id);
  //       return data.response[0].id;
  //     })
  //     .catch((err) => console.error(err));
  // };

  // const getOrderStatusSold = () => {
  //   return orderStatus({ orderStatusName: "Sold" })
  //     .then((data) => {
  //       setOrderStatusSold(data.response[0].id);
  //       return data.response[0].id;
  //     })
  //     .catch((err) => console.error(err));
  // };

  const getOccation = (
    orderSaleStatus,
    orderTransferStatus,
    orderSoldStatus,
  ) => {
    setLoading(true);
    setSize(2000);
      getProduct(size,{
        branch: getBranchId(),
        productLabel: '108 MAHAVEL', 
        removeNTP: "NTP-",
        removeHP: "HP-",
        beforeCreatedAt: currentRegister(),
        sortType: true,
        demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
        statusId: `${orderSaleStatus},${orderTransferStatus},${orderSoldStatus}`
      })
        .then((data) => {
        //   setCategoryList(data.response.content);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
        });
  }

  const getVelProductDetails = async() => {
    const responseData = await ECommerce('vel_product_list')
    const velProductData = JSON.parse(responseData.response.moduleField)
    setCategoryList(velProductData)
    console.log('zadfsa',velProductData);
    
    const categories = ["All", ...new Set(velProductData
    .filter(item => item.categoryName)
    .map(item => item.categoryName)
    .sort()
  )];
  
  setUniqueCategories(categories);
  }

  const updateCategoryData = (category) => {
    setSelectedCategory(category)
  // setColorCode(categoryColorMap[category]);
  }


  // const handleMenuItemClick = (menuItem) => {
  //   setSelectedOption(menuItem)
  //   history(`/${menuItem.value}`)  
  // };

  function banners() {
    // configImages &&
    //   configImages.E_COMMERCE_BANNERS.forEach((data) => {
    //     if (data.key === "newArrivals") {
    //       setBanner(data.value);
    //     }
    //   });
    setBanner(BannerImage)
  };

  return (
    <div className="vel-series-container">
     {showHeaders ? (
  banner && banner.length > 0 ? (
    <img 
      src={banner} 
      alt="108 Divine Vel Series" 
      className="vel-banner"
    />
  ) : (
    <div className="vel-skeleton vel-skeleton-image"></div>
  )
) : null}

      {/* Breadcrumb Navigation */}
      {showHeaders ? (
      <div className="vel-breadcrumb px-3 px-sm-5">
        <Link to="/" className="vel-breadcrumb-link">
          Home
        </Link>
        /
        <span className="vel-breadcrumb-current">
          108 MAHAVEL
        </span>
      </div>
      ) : null}
      {/* {uniqueCategories.length > 0 && (
    <div className="container container-influid-md">
      <div className="vel-category-filter-wrapper">
        <div className="vel-language-filter">
        <Select
          options={languageOptions}
          value={selectedLanguage}
          onChange={(selected) => setSelectedLanguage(selected)}
          className="vel-language-select"
          classNamePrefix="vel-select"
          placeholder="Language"
          isSearchable={false}
          isClearable={false}
        />
      </div>
        <div className="vel-category-filter">
          <Select
            options={categoryOptions}
            value={{ value: selectedCategory, label: selectedCategory }}
            onChange={(selected) => updateCategoryData(selected.value)}
            className="vel-category-select"
            classNamePrefix="vel-select"
            placeholder="Filter by category"
            isSearchable={true}
            isClearable={false}
          />
        </div>
      </div>
    </div>
)} */}

{languageOptions.length > 0 && (
  <div className="m-2">
    <Label className="mb-2 font-weight-bold">Language</Label>

    <div className="language-scroll">
      {languageOptions.map((item) => (
        <div
          key={item.label}
          className={`filter-item ${
            selectedLanguage?.label === item.label
              ? "filter-item-selected"
              : ""
          }`}
          onClick={() => setSelectedLanguage(item)}
        >
          {item.label}
        </div>
      ))}
    </div>
  </div>
)}


   {categoryOptions.length > 0 && (
  <div className="m-2">
    <Label className="mb-2 font-weight-bold">Category</Label>

    <div className="category-scroll">
      {categoryOptions.map((item) => (
        <div
          key={item.label}
          className={`filter-item ${
            selectedCategory.label === item.label
              ? "filter-item-selected"
              : ""
          }`}
          onClick={() => updateCategoryData(item)}
        >
          {item.label}
        </div>
      ))}
    </div>
  </div>
)}

    
      {/* 108 MAHAVEL Center Display */}
      {showHeaders ? (
      <div className="vel-header">
        <div className="position-relative d-inline-block">
          <h1 className="vel-main-title">
            108 Divine Vel Series
          </h1>
          <div className="vel-title-underline"></div>
        </div>
        <p className="vel-subtitle">
          Exquisite Collection of Divine Jewellery
        </p>
      </div>
        ) : null}

      <div className="vel-series-products">
        <div className="container container-influid-md">
          {/* Product Grid */}
          <div className="vel-grid">
            {filteredProducts.length === 0 && !loading ? (
              <div className="vel-no-data">
                <img src={no_data} alt="no-data" className="vel-no-data-img" />
                <p className="vel-no-data-text">No products available at the moment</p>
              </div>
            ) : (
              filteredProducts.map((categoryItem, index) => (
                <div 
                  key={index}
                  className="vel-card"
                  onClick={() =>
                    history(`/VelProductDetails/${categoryItem.id}`, {state:{categoryItem,selectedLanguage}})
                  }
                >
                  <div className="vel-card-image">
                    <img
                      src={categoryItem.Url || Noimg}
                      alt={selectedLanguage.label === 'English' ? categoryItem.productName : categoryItem.productNameTa}
                      className="vel-card-img"
                    />
                    
                    {/* Stock Badge */}
                    {categoryItem.stockStatus === "Sale" ? (
                      <div className="vel-stock-badge">
                        <i className="bi bi-check-circle"></i> Available
                      </div>
                    ) : (
                      <div className="vel-stock-badge" style={{backgroundColor:categoryItem.colorCode}}>
                        <i className="bi bi-clock"></i> Order Now
                      </div>
                    )}
                    
                    {/* Quick View Overlay */}
                    <div className="vel-quick-view">
                      <button className="vel-quick-view-btn">
                        <i className="bi bi-eye"></i> Quick View
                      </button>
                    </div>
                  </div>
                  
                  <div className="vel-card-content">
                    <h3 className="vel-card-title">
                      {selectedLanguage.label === 'English' ? categoryItem.productName : categoryItem.productNameTa}
                    </h3>
                    {/* <p className="vel-card-material" title={categoryItem.material}>
                      {categoryItem.material || "Premium Jewellery"}
                    </p> */}
                    
                    {/* View Details Button */}
                    <button
                      className="vel-customize-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        history(`/VelProductDetails/${categoryItem.id}`, { state: { categoryItem,language:selectedLanguage } });
                      }}
                    >
                      Customize <i className="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              ))
            )}
            
            {/* Loading Skeletons */}
            {loading && Array.from({ length: 8 }).map((_, index) => (
              <div key={`skeleton-${index}`} className="vel-card">
                <div className="vel-skeleton vel-skeleton-image"></div>
                <div className="vel-card-content">
                  <div className="vel-skeleton vel-skeleton-title"></div>
                  <div className="vel-skeleton vel-skeleton-material"></div>
                  <div className="vel-skeleton vel-skeleton-button"></div>
                </div>
              </div>
            ))}
          </div>
          
          {/* View More Button */}
          {/* <div className="d-flex justify-content-center pt-5 mt-3">
            <button
              className="btn btn-outline-custom px-5 py-3 rounded-pill fw-medium"
              onClick={() => {
                getOccation(
                  orderStatusSale,
                  orderStatusTransfer,
                  orderStatusSold,
                );
              }}
              style={{
                borderColor: '#d4af37',
                color: '#d4af37',
                transition: 'all 0.3s ease',
                minWidth: '180px'
              }}
              disabled={loading}
              tw="hover:bg-custom-100 hover:text-white hover:border-custom-100"
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Loading...
                </>
              ) : (
                <>
                  View More <i className="bi bi-chevron-down ms-2"></i>
                </>
              )}
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VelSeriesDetails;